import {isLeadsBoardVisible, isSellingBoardVisible, isWonBoardVisible} from 'selectors/routing'

export const getOpportunitiesView = state => state.salesContext.opportunitiesView

export const getLeadsOpportunities = state => state.salesContext.leadsView.opportunities || {}
export const getLeadsPages = state => state.salesContext.leadsView.pages || {}
export const getLeadsCounts = state => state.salesContext.leadsView.counts || {}
export const getLeadsValues = state => state.salesContext.leadsView.values || {}
export const getLeadsLoading = state => state.salesContext.leadsView.loading || {}
export const getLeadsSearch = state => state.salesContext.leadsView.search

export const getLeadsFilters = state => {
  const {company, createdStart, createdEnd, createdTimeKey} = state.salesContext.leadsView
  return {company, createdStart, createdEnd, createdTimeKey}
}

export const getSellingOpportunities = state => state.salesContext.sellingView.opportunities || {}
export const getSellingPages = state => state.salesContext.sellingView.pages || {}
export const getSellingCounts = state => state.salesContext.sellingView.counts || {}
export const getSellingValues = state => state.salesContext.sellingView.values || {}
export const getSellingLoading = state => state.salesContext.sellingView.loading || {}
export const getSellingSearch = state => state.salesContext.sellingView.search

export const getSellingFilters = state => {
  const {
    company, expectedStart, expectedEnd, expectedTimeKey,
    nextActivityStart, nextActivityEnd, nextActivityTimeKey,
  } = state.salesContext.sellingView
  return {
    company, expectedStart, expectedEnd, expectedTimeKey,
    nextActivityStart, nextActivityEnd, nextActivityTimeKey,
  }
}

export const getWonOpportunities = state => state.salesContext.wonView.opportunities || {}
export const getWonPages = state => state.salesContext.wonView.pages || {}
export const getWonCounts = state => state.salesContext.wonView.counts || {}
export const getWonValues = state => state.salesContext.wonView.values || {}
export const getWonLoading = state => state.salesContext.wonView.loading || {}
export const getWonSearch = state => state.salesContext.wonView.search

export const getWonFilters = state => {
  const {company, wonStart, wonEnd, wonTimeKey} = state.salesContext.wonView
  return {company, wonStart, wonEnd, wonTimeKey}
}

export const isAnySuccessStatsVisible = state => {
  return (
    (isLeadsBoardVisible(state) && isLeadsSuccessStatsVisible(state)) ||
    (isSellingBoardVisible(state) && isSellingSuccessStatsVisible(state)) ||
    (isWonBoardVisible(state) && isWonSuccessStatsVisible(state))
  )
}

export const isLeadsSuccessStatsVisible = state => state.salesContext.successStats.visibleLeads
export const isSellingSuccessStatsVisible = state => state.salesContext.successStats.visibleSelling
export const isWonSuccessStatsVisible = state => state.salesContext.successStats.visibleWon

export const getSuccessStats = state => state.salesContext.successStats.stats
export const getSuccessStatsLoading = state => state.salesContext.successStats.loading

export const getSuccessStatsFilters = state => {
  const {stageModifiedStart, stageModifiedEnd, stageModifiedTimeKey} = state.salesContext.successStats
  return {stageModifiedStart, stageModifiedEnd, stageModifiedTimeKey}
}

export const getUserOrTeam = state => state.salesContext.userOrTeam
export const getJobTypes = state => state.salesContext.jobTypes
export const getShowDormants = state => state.salesContext.showDormants
export const getSalesAnalysisQuoteFilters = state => state.salesContext.salesAnalysisView.quoteDataSource
export const getSalesAnalysisInvoiceFilters = state => state.salesContext.salesAnalysisView.invoiceDataSource
export const getSalesAnalysisDataSource = state => state.salesContext.salesAnalysisView.dataSource
export const getSalesAnalysisQuotesTotal = state => state.salesContext.salesAnalysisView.quoteDataSource.total
export const getSalesAnalysisQuotesTotalCost = state =>
  state.salesContext.salesAnalysisView.quoteDataSource.totalCostSum
export const getSalesAnalysisQuotesTotalMargin = state =>
  state.salesContext.salesAnalysisView.quoteDataSource.totalMargin
export const getSalesAnalysisInvoicesTotal = state =>
  state.salesContext.salesAnalysisView.invoiceDataSource.total
export const getSalesAnalysisInvoicesLayout = state =>
  state.salesContext.salesAnalysisView.invoiceDataSource.layoutId
export const getSalesAnalysisQuotesLayout = state =>
  state.salesContext.salesAnalysisView.quoteDataSource.layoutId
export const getSalesAnalysisQuotesIsOverriding = state =>
  state.salesContext.salesAnalysisView.quoteDataSource.isOverriding
export const getSalesAnalysisInvoicesIsOverriding = state =>
  state.salesContext.salesAnalysisView.invoiceDataSource.isOverriding
export const getSalesAnalysisDataSourceLayoutPanels = state =>
  state.salesContext.salesAnalysisView.layoutPanels
